module.exports = __webpack_public_path__ + "img/2023.1c379122.jpg";